import React from "react";
import Globalclasses from "../../App.module.css";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import ListItemText from "@material-ui/core/ListItemText";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import Grid from "@material-ui/core/Grid";

import OfflineDb from "../../db";
import { apiServices } from "../../services/apiServices";
import swal from "sweetalert";
import CheckIcon from "@material-ui/icons/Check";
import { useGlobalSpinnerActionsContext } from "../../context/GlobalSpinnerContext";

import "../../assets/css/customstyles.css";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function Disclaimer(props) {
  const [sessionUserBoValue, setSessionUserBoValue] = React.useState(
    props.sessionUserBoValue
  );
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);
  const setGlobalSpinner = useGlobalSpinnerActionsContext();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  function updateUserConsent() {
    sessionUserBoValue.attributeValues[props.userConsentAttributeIndex].value =
      "true";
    OfflineDb.setDataIntoPouchDB("loginDetails", sessionUserBoValue);
    setGlobalSpinner(true);
    apiServices
      .putAPI(`users/${sessionUserBoValue.id}`, sessionUserBoValue)
      .then((res) => {
        setGlobalSpinner(false);

        swal({
          title: "Done",
          text: res.data.message,
          icon: "success",
          button: "Close",
        }).then((res) => {
          setOpen(false);
          props.userConsent();
        });
      });
  }
  function disagree() {
    OfflineDb.deleteDatabse()
      .then((res) => {
        window.location.reload();
      })
      .catch((err) => {
        window.location.reload();
      });
  }

  // return (
  //   <div className={Globalclasses.container}>
  //     <main
  //       style={{
  //         display: "flex",
  //         height: "100%",
  //         width: "100%",
  //       }}
  //     >
  //       <section
  //         style={{
  //           backgroundColor: "#fff",
  //           flexGrow: 1,
  //           padding: 0,
  //           overflow: "hidden",
  //         }}
  //       >
  //         <Grid container spacing={3} className="margin-top-100px">
  //           <Grid item xs={12} sm={12} md={12} className="">
  //             <div className="innerdiv">
  //               <p className="zero text-center">
  //                 <div className="useravtarimg" />
  //               </p>
  //             </div>
  //           </Grid>
  //           <Grid item xs={12} sm={12} md={12} className="">
  //             <p>{props.disclaimerContents}</p>
  //             <div className="mt-60px disclaimercontainer">
  //               {/* <pre>{JSON.stringify(props.programData, 0, 2)}</pre> */}
  //               {/* <p>{props}</p> */}
  //               <p className="disclaimerbuttonlist">
  //                 <Button
  //                   variant="contained"
  //                   color=""
  //                   className={classes.button}
  //                   startIcon={<CheckIcon />}
  //                   onClick={() => updateUserConsent()}
  //                 >
  //                   Agree
  //                 </Button>
  //                 <Button
  //                   variant="contained"
  //                   color="secondary"
  //                   className={classes.button}
  //                   startIcon={<CloseIcon />}
  //                   onClick={() => disagree()}
  //                 >
  //                   Disagree
  //                 </Button>
  //               </p>
  //             </div>
  //           </Grid>
  //         </Grid>
  //       </section>
  //     </main>
  //   </div>
  // );

  return (
    <div>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <Typography variant="h6" className={classes.title}>
              Disclaimer
            </Typography>

            {/* <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton> */}
          </Toolbar>
        </AppBar>
        <div className="mt-60px disclaimercontainer">
          <Grid item xs={12} sm={12} md={12} className="">
            <div className="innerdiv">
              <p className="zero text-center">
                <div className="useravtarimg" />
              </p>
            </div>
          </Grid>
          {/* <pre>{JSON.stringify(props.programData, 0, 2)}</pre> */}
          {/* <p>{props}</p> */}
          
            <Grid contianer justifyContent="center" spacing={2}>
              <Grid item xs={12} sm={12} md={12}>
                <p>
                  By downloading the WHO Global Prevent TB mobile app (the
                  “Application”), you - as user of the Application - agree to
                  accept the terms of use, copyright notice and the disclaimers
                  here below: In any use of this work, there should be no
                  suggestion that WHO endorses any specific organization,
                  products or services. The use of the WHO logo is not
                  permitted. If you adapt the work, then you must license your
                  work under the same or equivalent Creative Commons license. If
                  you create a translation of this work, you should add the
                  following disclaimer along with the suggested citation: “This
                  translation was not created by the World Health Organization
                  (WHO). WHO is not responsible for the content or accuracy of
                  this translation? The original English edition shall be the
                  binding and authentic edition”.Any mediation relating to
                  disputes arising under the license shall be conducted in
                  accordance with the mediation rules of the World Intellectual
                  Property Organization.General disclaimers: The mention of
                  specific companies or of certain manufacturers’ products does
                  not imply that they are endorsed or recommended by the World
                  Health Organization in preference to others of a similar
                  nature that are not mentioned.The World Health Organization
                  does not warrant that the information contained on this
                  Application is complete and correct. The Organization shall
                  not be liable for any damages incurred as a result of use of
                  the data or programs.The generic Prevent TB platform is made
                  available to the countries for training, adapting to country
                  specific needs and testing in the country ecosystem. This
                  instance and environment should not be used for capturing real
                  patient data. For actual implementation and rolling out of
                  this platform beyond testing, we request the countries to
                  contact us for supporting country program specific roll-out.
                </p>
              </Grid>
            </Grid>
          

          <p className="disclaimerbuttonlist">
            <Button
              variant="contained"
              color=""
              className={classes.button}
              startIcon={<CheckIcon />}
              onClick={() => updateUserConsent()}
            >
              Agree
            </Button>
            <Button
              variant="contained"
              color="secondary"
              className={classes.button}
              startIcon={<CloseIcon />}
              onClick={() => disagree()}
            >
              Disagree
            </Button>
          </p>
        </div>
      </Dialog>
    </div>
  );
}
